/**
 * Imperative sidebar “active item” sync (legacy template).
 * Must run at most once per route change — running inside every <Dropdown> caused
 * duplicate work and React Router–related crashes (e.g. endsWith on undefined).
 */

function removeActivation(items: HTMLElement[]) {
  items.forEach((item) => {
    if (item?.classList?.contains("dropdown-button")) {
      const menu = item?.nextElementSibling;
      menu?.classList.add("hidden");
    }
    if (item?.classList?.contains("active")) {
      item.classList.remove("active");
      item.classList.remove("show");
      const parentEle = item?.closest(".dropdown-content");
      if (parentEle) {
        parentEle.classList.add("hidden");
      }
    }
  });
}

function activeOnLoad(item: HTMLElement) {
  if (item?.classList?.contains("dropdown-content")) {
    if (item?.parentElement) {
      const parentButton = item?.parentElement.children[0] as HTMLElement | undefined;
      parentButton?.classList.add("show");
      const mainAttrItem = item?.closest("div[main-item]");
      item?.parentElement?.children?.[1]?.classList?.add("hidden");
      mainAttrItem?.querySelector(".dropdown-content")?.classList.remove("hidden");
    }
  } else {
    item?.classList.add("active");
    item?.classList.add("show");

    let parentCollapseDiv = item?.closest(".dropdown-content") as HTMLElement | null;
    if (
      document.documentElement.getAttribute("data-layout") === "vertical" &&
      document.documentElement.getAttribute("data-sidebar-size") !== "sm"
    ) {
      parentCollapseDiv?.classList.remove("hidden");
      parentCollapseDiv?.classList.remove("hidden");
    }
    const parentDropButton = parentCollapseDiv?.parentElement?.firstChild as HTMLElement | undefined;
    parentDropButton?.classList.add("active");
    parentDropButton?.classList.add("show");

    const mainParentContent = parentCollapseDiv?.parentElement?.closest(
      ".dropdown-content"
    ) as HTMLElement | null;
    if (mainParentContent) {
      if (
        document.documentElement.getAttribute("data-layout") === "vertical" &&
        document.documentElement.getAttribute("data-sidebar-size") !== "sm"
      ) {
        mainParentContent?.classList.remove("hidden");
      }
      const mainButton = mainParentContent?.parentElement?.children?.[0] as HTMLElement | undefined;
      mainButton?.classList.add("active", "show");
    }
  }
}

export function runInitSidebarActiveMenu(pathname: string) {
  try {
    const pub =
      typeof process.env.PUBLIC_URL === "string" ? process.env.PUBLIC_URL : "";
    const loc = pathname || "";
    const pathName = `${pub}${loc}`;
    const ul = document.getElementById("navbar-nav");
    if (!ul) return;
    const items = ul.getElementsByTagName("a");
    const itemsArray = Array.from(items) as HTMLElement[];
    removeActivation(itemsArray);
    const matchingMenuItem = itemsArray.find((x) => {
      try {
        return (x as HTMLAnchorElement).pathname === pathName;
      } catch {
        return false;
      }
    });
    if (matchingMenuItem) {
      activeOnLoad(matchingMenuItem);
    }
  } catch (e) {
    console.warn("[sidebarActiveMenuDom] init skipped:", e);
  }
}
